/**************************************************
 * Nombre:       Dialogo_Cange_Puntos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {PublishedWithChangesOutlined} from '@mui/icons-material'
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import logo from '../../Recursos/logo_redondo.svg'
import {useContext, useEffect, useState} from "react";
import {usuarioContext} from "../../App";
import {theme} from "../../Tema";
import {obtenerTotalPuntos} from "../../CodigoCliente/Puntos/obtenerTotalPuntos";
import {realizarCange} from "../../CodigoCliente/Bonos/realizarCange";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import Formulario_Cange from "../Formularios/Formulario_Cange";
import {useNavigate} from "react-router";

const Dialogo_Cange_Puntos = ({cerrar, realizado, datos}) => {
    const cData = useContext(usuarioContext)
    const navigate = useNavigate()
    const [totalPuntos, setTotalPuntos] = useState(0);
    const {props, setEntidad, obtenerEntidad} = useFormulario({valoresDefecto: {}})
    const {Cargador, Avisos, iniciarCarga, nuevoAviso, terminar} = useCargador({
        logoRedondo: logo,
        funcionUno: realizado,
        funcionDos: cerrar,
    })
    const [cargando, setCargando] = useState(false)

    const subirDatos = () => {
        setCargando(true)
        enviarDatos().then((dox) => {
            setCargando(false)
        })
    }

    const enviarDatos = async () => {

        if (datos.valor <= totalPuntos) {
            setCargando(true)
            let entidad = await obtenerEntidad()
            iniciarCarga('Creando solicitud')
            await realizarCange({usuario: cData.usuario, puntos: datos.valor, premio: datos, entidad: entidad})
            terminar({aviso: 'Solicitud creada con exito, pronto nos comunicaremos contigo'})
            navigate('/Historial')
            setCargando(false)

        }

    }

    useEffect(() => {

        obtenerTotalPuntos(cData.usuario.id).then((dox) => {
            setTotalPuntos(dox);
        })


        setEntidad({...cData.usuario, ...datos})

    }, [datos]);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            spacing={2}
        >

            <Cargador/>

            <Avisos/>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center',}}>
                <Typography sx={{fontSize: 16, fontWeight: 400}}>Total Puntos</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: -2.5}}>
                <Typography sx={{fontSize: 24, fontWeight: 600, color: theme.palette.primary.main}}>
                    {totalPuntos}
                </Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    spacing={0}
                >

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography
                            sx={{
                                fontWeight: 600,
                                fontSize: 14,
                                color: theme.palette.primary.main
                            }}>{'Nombre'}</Typography>

                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography
                            sx={{
                                fontWeight: 400,
                                lineHeight: 1.1
                            }}>{datos.nombre}</Typography>

                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                        <Typography sx={{
                            fontWeight: 600,
                            fontSize: 14,
                            color: theme.palette.primary.main
                        }}>Descripcion:</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography
                            sx={{
                                fontWeight: 400,
                                lineHeight: 1.1
                            }}>{datos.descripcion}</Typography>

                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                        <Typography sx={{fontWeight: 600, fontSize: 14, color: theme.palette.primary.main}}>Tiempo de
                            entrega:</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography
                            sx={{
                                fontWeight: 400,
                                lineHeight: 1.1
                            }}>{datos.tiempo}</Typography>

                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                        <Typography sx={{fontWeight: 600, fontSize: 14, color: theme.palette.primary.main}}>Puntos
                            necesarios:</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography
                            sx={{
                                fontWeight: 400,
                                lineHeight: 1.1
                            }}>{datos.valor} </Typography>

                    </Grid>

                </Grid>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-end'}}>
                <img src={datos.img} width={'90%'} height={'auto'}
                     style={{borderRadius: 10,}}/>
            </Grid>

            {!datos.dinero &&
                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Formulario_Cange props={props}/>
                </Grid>
            }

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mb: 2}}>
                <Button
                    loading={cargando}
                    disabled={totalPuntos <= datos.valor}
                    onClick={() => subirDatos()}
                    startIcon={<PublishedWithChangesOutlined/>}>Solicitar Canje</Button>
            </Grid>


        </Grid>
    )

}
export default Dialogo_Cange_Puntos